import React, { Component } from 'react'
import PropTypes from 'prop-types'

const NewsItem =(props)=> {


 
    let { title, description, imgurl, newsurl, author, date, source } = props;
    // console.log(title+" "+source);
    return (
      <div className="my-3 mx-3">

        <div className="card">

          {/* style={{width: "18rem"}} */}
          {/* <img src={imgurl} className="card-img-top" alt="..."/> */}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            position: 'absolute',
            right: '0'
          }}>
            <span className="badge rounded-pill bg-danger"> {source} </span>
            {/* <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger" style={{ left: '90%', zIndex: '1' }}> {source} </span> */}

          </div>
          
          <img src={!imgurl ? "https://bcchamber.org/wp-content/uploads/2020/05/News-Default-640x400.jpg" : imgurl} className="card-img-top" alt="..." />
          <div className="card-body">
            
            {/* <h5 className="card-title">{title.replace(""+source," ")} */}
            <h5 className="card-title">{title.split("- "+source)}
            </h5>
            {/* <h5 className="card-title">{title}</h5> */}
            <p className="card-text">{description}</p>
            <a href={newsurl} target="_blank" className="btn btn-sm btn-dark">Read More...</a>
            <p className="card-text"><small className="text-muted">By the {!author ? "Unknown-Author" : author} on {new Date(date).toGMTString()}</small></p>

          </div>
        </div>

      </div>
    )

}

export default NewsItem
